export type { Order, CurrencyInfo, DetailedSaleItem, SaleCoupon } from '@src/domains/orders/types/order';
export { OrderStatus } from '@src/domains/orders/types/order';
export { getOrderSaleItems } from '@src/domains/orders/core/getOrderSaleItems';
export { findDirectLinkOrder } from '@src/domains/orders/core/findDirectLinkOrder';
export { isOpenOrder, OPEN_ORDER_STATUSES } from '@src/domains/orders/core/isOpenOrder';
export { toSellerTemplateOrder } from '@src/domains/orders/core/toSellerTemplateOrder';
export type { SellerTemplateOrder } from '@src/domains/orders/core/toSellerTemplateOrder';
export { getOrderReservations } from '@src/domains/orders/core/getOrderReservations';
export type { OrderReservation } from '@src/domains/orders/core/getOrderReservations';
export { getOrderPaymentSummary } from '@src/domains/orders/core/getOrderPaymentSummary';
export type { OrderPaymentSummary } from '@src/domains/orders/core/getOrderPaymentSummary';
export { getOrderServiceFeeDescriptions } from '@src/domains/orders/core/getOrderServiceFeeDescriptions';
export {
  getOrderTotalCurrencyInfo,
  getOrderServiceFeeCurrencyInfo,
  getOrderCoupon,
  getOrderRepresentativeCoupon,
  getOrderProductCount,
  getOrderSubtotalCents,
  getOrderTotalAmountCents,
  isOrderCouponApplied,
  getOrderCouponCode,
  getOrderCombinedCoupon,
  getOrderSummarySubtotalCurrencyInfo,
} from '@src/domains/orders/core/orderSummary';
export { getOrderSaleChangesAmount } from '@src/domains/orders/core/getOrderSaleChangesAmount';

export { organizeFormInputs } from '@src/domains/orders/core/form-inputs/organizeFormInputs';
export { countFormInputs } from '@src/domains/orders/core/form-inputs/countFormInputs';
export { hasPendingFormInputs } from '@src/domains/orders/core/form-inputs/hasPendingFormInputs';
export type { FormInputsCollection } from '@src/domains/orders/core/form-inputs/hasPendingFormInputs';
export { areAllFormInputsFilled } from '@src/domains/orders/core/form-inputs/areAllFormInputsFilled';
export { collectFormInputValues } from '@src/domains/orders/core/form-inputs/collectFormInputValues';
export {
  formInputDateToDisplay,
  formInputDateToIso,
  isValidFormInputDisplayDate,
} from '@src/domains/orders/core/form-inputs/formInputDate';
export { normalizeFormInputValue } from '@src/domains/orders/core/form-inputs/normalizeFormInputValue';
export { indexFormInputErrorsByHash } from '@src/domains/orders/core/form-inputs/indexFormInputErrorsByHash';
export { resolveFormInputErrorMessage } from '@src/domains/orders/core/form-inputs/resolveFormInputErrorMessage';
export type { FormInputValue } from '@src/domains/orders/core/form-inputs/types';
export { FormInputsState } from '@src/domains/orders/core/form-inputs/types';

export { formInputGroupKey } from '@src/domains/orders/core/form-inputs/formInputGroupKey';
export { groupTariffUnits } from '@src/domains/orders/core/form-inputs/groupTariffUnits';
export type { TariffUnitGroup } from '@src/domains/orders/core/form-inputs/groupTariffUnits';
export { organizeFormInputsBySaleItem } from '@src/domains/orders/core/form-inputs/organizeFormInputsBySaleItem';
export type { SaleItemFormInputGroup } from '@src/domains/orders/core/form-inputs/organizeFormInputsBySaleItem';
export {
  resolveFormInputValue,
  isFormInputGroupFilled,
  countFilledFormInputGroups,
  firstPendingFormInputGroupKey,
} from '@src/domains/orders/core/form-inputs/formInputGroupState';
export type { FormInputValues } from '@src/domains/orders/core/form-inputs/formInputGroupState';
export { formInputGroupsWithErrors } from '@src/domains/orders/core/form-inputs/formInputGroupsWithErrors';
export { buildFormInputPayload } from '@src/domains/orders/core/form-inputs/buildFormInputPayload';
